import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { ToastProvider } from "@/components/ui/Toast";
import { PwaUpdateToast } from "@/pwa/PwaUpdateToast";
import { ApiError } from "./api/client";
import { router } from "./router";

// `networkMode: "always"`: offline, reads are answered by the service-worker cache and writes
// by the offline queue (B2), so TanStack must not pause them while `navigator.onLine` is false.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) => !(error instanceof ApiError) && count < 2,
      refetchOnWindowFocus: true,
      staleTime: 10_000,
      networkMode: "always",
    },
    mutations: { networkMode: "always" },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <PwaUpdateToast />
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  );
}
